import axios from "axios";
import { api_url } from "../config/config";
import userAdapters from "../adapters/userAdapters";

export const userService = {
  // Review sprint20 — user connecté (route `me`, même endpoint que le bootstrap
  // d'AuthMiddleware). Sert à rafraîchir des données périssables du user en
  // cache, comme les URLs signées des tampons (30 min sur S3).
  getUtilisateurConnecte: () => {
    return axios.get(`${api_url}user`);
  },
  getAllUsers: () => {
    return axios.get(`${api_url}users/search?paginate=0`);
  },
  getUsers: (search) => {
    return axios.get(`${api_url}users/search${search}`);
  },
  getUser: (uuid) => {
    return axios.get(`${api_url}users/${uuid}`);
  },
  createUser: (data) => {
    return axios.post(`${api_url}users`, userAdapters.transformForAPI(data));
  },
  updateUser: (data) => {
    return axios.put(
      `${api_url}users/${data.uuid}`,
      userAdapters.transformForAPI(data)
    );
  },
  deleteUser: (uuid) => {
    return axios.delete(`${api_url}users/${uuid}`);
  },
  // LS-685 — signature de l'utilisateur connecté (self-service).
  // LS-689 — `type` ne vaut plus que "signature" : les tampons, devenus multiples
  // et nommés, ont leurs propres routes (voir plus bas).
  uploadImage: (type, file) => {
    const formData = new FormData();
    formData.append("file", file);
    return axios.post(`${api_url}user/images/${type}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  deleteImage: (type) => {
    return axios.delete(`${api_url}user/images/${type}`);
  },
  // LS-685 — signature d'un autre utilisateur, réservé au SUPER_ADMIN
  // (GlobalAccess::GERER_IMAGE_UTILISATEUR côté API).
  uploadImageForUser: (uuid, type, file) => {
    const formData = new FormData();
    formData.append("file", file);
    return axios.post(`${api_url}users/${uuid}/images/${type}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  deleteImageForUser: (uuid, type) => {
    return axios.delete(`${api_url}users/${uuid}/images/${type}`);
  },
  // LS-689 — tampons multiples et nommés de l'utilisateur connecté. Le dépôt et
  // le renommage renvoient le user complet (`tampons` à jour, trié par nom) ; la
  // suppression répond 204, au appelant de retirer l'entrée localement.
  uploadTampon: (file, nom) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("nom", nom);
    return axios.post(`${api_url}user/tampons`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  renameTampon: (tamponUuid, nom) => {
    return axios.patch(`${api_url}user/tampons/${tamponUuid}`, { nom });
  },
  deleteTampon: (tamponUuid) => {
    return axios.delete(`${api_url}user/tampons/${tamponUuid}`);
  },
  // LS-689 — mêmes actions sur le compte d'un autre utilisateur, réservé au
  // SUPER_ADMIN. Le tampon déposé appartient à l'utilisateur ciblé : l'admin ne
  // pourra pas s'en servir pour ses propres accords de financement.
  uploadTamponForUser: (uuid, file, nom) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("nom", nom);
    return axios.post(`${api_url}users/${uuid}/tampons`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  renameTamponForUser: (uuid, tamponUuid, nom) => {
    return axios.patch(`${api_url}users/${uuid}/tampons/${tamponUuid}`, { nom });
  },
  deleteTamponForUser: (uuid, tamponUuid) => {
    return axios.delete(`${api_url}users/${uuid}/tampons/${tamponUuid}`);
  },
};
